import { Card } from "@peer-start/ui";
import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ValidationWarning({ warning }: { warning?: string }) {
  const { t } = useTranslation();
  return (
    <Card padding="compact" className="bg-warning text-warning-foreground">
      <div className="flex gap-2.5 text-sm">
        <ShieldAlert aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
        <p>
          <span className="font-medium">{t("passportVig.validation.title")}:</span>{" "}
          {warning ?? t("passportVig.validation.description")}
        </p>
      </div>
    </Card>
  );
}
